/** Formatos de exibicao em pt-BR, iguais em todas as telas. */

const REAL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** 419000 -> "R$ 4.190,00" */
export const reais = (centavos: number | null | undefined): string =>
  centavos == null ? '' : REAL.format(centavos / 100);

/** "4.190,00" ou "4190" -> 419000; null se nao for numero. */
export function centavosDe(texto: string): number | null {
  const limpo = texto.replace(/[^\d,.-]/g, '');
  if (limpo === '') return null;
  const normal = limpo.includes(',') ? limpo.replace(/\./g, '').replace(',', '.') : limpo;
  const n = Number(normal);
  return Number.isFinite(n) ? Math.round(n * 100) : null;
}

/** "2026-10-30" -> "30/10/2026" */
export function data(iso: string | null | undefined): string {
  if (iso == null || iso === '') return '';
  const [a, m, d] = iso.slice(0, 10).split('-');
  return `${d}/${m}/${a}`;
}

/** Instante -> "30/10/2026 14:05", no fuso de Sao Paulo. */
export function dataHora(iso: string | null | undefined): string {
  if (iso == null || iso === '') return '';
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  }).format(new Date(iso));
}

/** Hoje (AAAA-MM-DD) em Sao Paulo, para comparar com campo `date`. */
export const hoje = (): string => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date());

/** Dias de diferenca entre duas datas AAAA-MM-DD (b - a). */
export function diasEntre(a: string, b: string): number {
  return Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 86_400_000);
}

/** "ha 3 dias", "hoje", "em 2 dias", relativo a hoje. */
export function relativo(iso: string | null | undefined): string {
  if (iso == null || iso === '') return '';
  const d = diasEntre(hoje(), iso.slice(0, 10));
  if (d === 0) return 'hoje';
  if (d === -1) return 'ontem';
  if (d === 1) return 'amanhã';
  return d < 0 ? `há ${-d} dias` : `em ${d} dias`;
}
